<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div v-show="exist_task_flag">
            <div style="margin-bottom:10px;">
                <el-alert
                    :title="tips"
                    type="warning"
                    show-icon>
                </el-alert>
            </div>
            <div class="my_todo"><span>待完成的任务：</span>
                <div class="badge_area">
                    <!-- <el-badge :value="ChengShu_todo" class="item">
                        <el-button @click="display_ChengShu_todo">管理基本功评估</el-button>
                    </el-badge> -->
                    <el-badge :value="JianKang_todo" class="item">
                        <el-button @click="display_JianKang_todo" style="width:168px;">组织健康度调研</el-button>
                    </el-badge>
                    <el-badge :value="TongDian_todo" class="item">
                        <el-button @click="display_TongDian_todo" style="width:168px;">管理痛点调研</el-button>
                    </el-badge>
                </div>
            </div>
            <!-- <router-view></router-view> -->
            <!-- 这里两个子组件需要使用v-show进行过滤，主要是为了让子组件随父组件一起加载，用v-if只有在点击显示的时候才会加载，这样就获取不到子组件的未完成数了！ -->
            <!-- <cheng-shu v-show="this.selected_assess=='管理基本功评估'" style="position:relative;top:-10px;" ref="chengshu_ref" @sendToDoNum="getToDoNum"></cheng-shu> -->
            <jian-kang v-show="this.selected_assess=='组织健康度调研'" style="position:relative;top:-10px;" ref="jiankang_ref" @sendToDoNum="getJKToDoNum">></jian-kang>
            <tong-dian v-show="this.selected_assess=='管理痛点调研'" style="position:relative;top:-10px;" ref="tongdian_ref" @sendToDoNum="getTDToDoNum"></tong-dian>
        </div>
        <div v-if="no_task_flag" class="no_task">
            <span>暂无待完成的任务，可<el-button type="text" @click="view_finished_info" class="view_details">单击此处</el-button>查看已完成的任务。</span>
        </div>
    </div>
</template>

<script>
// import chengShu from "./ChengShu_todo.vue";
import jianKang from "./JianKang_todo.vue";
import tongDian from "./TongDian_todo.vue";
import getdata from "@/api/getData.js";

export default {
    beforeCreate() {
        // 如果path中有有效的id，则判断id是否有效，否则正常校验用户token
        let login_random_series = this.$route.query.id;
        if((typeof(login_random_series) == "undefined") || (login_random_series == '')){
            getdata.getList("checklogin")
                .then(() => {
                    // if(resp.data.usertype=='ceo'){
                    //     this.$router.push({
                    //         path: '/JK/dataCenter',
                    //     });
                    // }else if(resp.data.usertype=='admin'){
                    //     console.log("from /JK/myass jump to /JK/tasks.");
                    //     this.$router.push({
                    //         path: '/JK/tasks',
                    //     });
                    // }
                })
                .catch(() => {
                    if(localStorage.getItem("token") != null){
                        this.$message({
                            message: '会话超时，请重新登录！',
                            type: 'warning',
                        })
                    }
                    this.$router.push({
                        path: '/JKlogin',
                    });
                    // if(typeof(log_random_series) == "undefined"){
                    //     this.$router.push({
                    //         path: '/JKlogin',
                    //     });
                    // }else{
                    //     console.log('log_random_series: ' + log_random_series);
                    // }
                })
        }
    },
    // 监控每个测评的未完成数，如果都完成了，则直接显示暂无待评估的任务
    watch: {
        JianKang_todo: {
            handler(val) {
                if(val==null && this.TongDian_todo==null){
                    this.exist_task_flag = false;
                    this.no_task_flag = true;
                }else{
                    this.exist_task_flag = true;
                    this.no_task_flag = false;
                }
            },
            immediate: true,
        },
        TongDian_todo: {
            handler(val) {
                if(val==null && this.JianKang_todo==null){
                    this.exist_task_flag = false;
                    this.no_task_flag = true;
                }else{
                    this.exist_task_flag = true;
                    this.no_task_flag = false;
                }
            },
            immediate: true,
        },
        // JianKang_todo: {
        //     handler(val) {
        //         if(val==null && this.ChengShu_todo==null){
        //             this.exist_task_flag = false;
        //             this.no_task_flag = true;
        //         }else{
        //             this.exist_task_flag = true;
        //             this.no_task_flag = false;
        //         }
        //     },
        //     immediate: true,
        // },
    },
    components: {
        // chengShu,
        jianKang,
        tongDian,
    },
    data() {
        return {
            selected_assess: '',
            ChengShu_todo: null,
            JianKang_todo: null,
            TongDian_todo: null,
            exist_task_flag: false,
            no_task_flag: false,
            tips: '亲爱的同学，您所提供的评价及其他内容都将做保密处理，仅用于组织健康度诊断与提升，请放心客观作答。',
        }
    },
    methods: {
        display_JianKang_todo() {
            // this.$router.push({
            //     path: '/jiankang_todo',
            // })
            this.selected_assess = '组织健康度调研';
        },
        display_TongDian_todo() {
            this.selected_assess = '管理痛点调研';
        },
        getJKToDoNum(num) {
            if(num<=0){
                this.JianKang_todo = null;
            }else{
                this.JianKang_todo = num;
            }
        },
        getTDToDoNum(num) {
            if(num<=0){
                this.TongDian_todo = null;
            }else{
                this.TongDian_todo = num;
            }
        },
        view_finished_info() {
            this.exist_task_flag = true;
            this.no_task_flag = false;
        },
    }
    // components: {
    //     quesmana,
    //     usermana,
    //     condmana,
    //     relationmana,
    // }
}
</script>

<style scoped>
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.badge_area {
    width: 100%;
    margin-top: 20px;
}
.el-badge {
    float: left;
    margin-right: 35px;
}
.el-badge /deep/ .el-button {
    font-size: 18px;
    font-weight: bold;
}
::v-deep .el-badge__content {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
.my_todo {
    text-align: left;
    border: 1px solid #E4E7ED;
    height: 100px;
    padding: 15px;
    background: #f5f7fa;
}
.my_todo span{
    font-size: 20px;
    font-weight: bold;
    color: #606266;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
}
.view_details {
  margin: 0 auto;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
  font-size: 16px;
}
</style>